import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";

export default function SiteLayout() {
  const { pathname } = useLocation();
  const overlay = pathname === "/";

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader overlay={overlay} />
      <main className={overlay ? "flex-1" : "flex-1 pt-16 md:pt-20"}>
        <Outlet />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}